import { app } from '@/main'
import i18next from '@/common/i18n'
import { extractErrorMessage } from './errorhandler'
import type { AxiosError } from 'axios'
import { DEFAULT_TOAST_LIFE } from '@/constants/toast'

type ToastParams = {
    severity: 'info' | 'warn' | 'error'
    summaryKey: string
    detailKey: string
    fallbackSummary?: string
    fallbackDetail?: string
    error?: AxiosError | unknown
}

type PrimeVueToast = {
    add(options: { severity: string; summary: string; detail?: string; life?: number }): void
}

function addToast(severity: 'info' | 'warn' | 'error', summary: string, detail?: string) {
    const gp = app.config.globalProperties as { $toast?: PrimeVueToast }
    const toast = gp.$toast
    if (!toast) return

    toast.add({ severity, summary, detail, life: DEFAULT_TOAST_LIFE })
}

export const showToast = ({
    severity,
    summaryKey,
    detailKey,
    fallbackSummary,
    fallbackDetail,
    error,
}: ToastParams) => {
    addToast(
        severity,
        i18next.t(summaryKey, fallbackSummary || 'Error'),
        error ? extractErrorMessage(error) : i18next.t(detailKey, fallbackDetail || '')
    )
}
